enum CandidateSettingCodeEnum {
  candEntRecruitMostMobile = 'CAND_ENT_RECRUIT_MOST_MOBILE',
  candEntRecruitMostDesktop = 'CAND_ENT_RECRUIT_MOST_DESKTOP',
  candJobsByActivityAreaMobile = 'CAND_JOBS_BY_ACTIVITY_AREA_MOBILE',
  candJobsByActivityAreaDesktop = 'CAND_JOBS_BY_ACTIVITY_AREA_DESKTOP',
  candLastJobsPublishedMobile = 'CAND_LAST_JOBS_PUBLISHED_MOBILE',
  candLastJobsPublishedDesktop = 'CAND_LAST_JOBS_PUBLISHED_DESKTOP',
  candSearchBarMaxChars = 'CAND_SEARCH_BAR_MAX_CHARS',
  candSearchAreaRange = 'CAND_SEARCH_AREA_RANGE',
  candSearchAreaRangeMin = 'CAND_SEARCH_AREA_RANGE_MIN',
  candSearchAreaRangeMax = 'CAND_SEARCH_AREA_RANGE_MAX',
  candSimilarJobsMobile = 'CAND_SIMILAR_JOBS_MOBILE',
  candSimilarJobsDesktop = 'CAND_SIMILAR_JOBS_DESKTOP',
  candProfilePictureSizeMax = 'CAND_PROFILE_PICTURE_SIZE_MAX',
  candTagsMax = 'CAND_TAGS_MAX',
  candTagsAutocompleteCharacters = 'CAND_TAGS_AUTOCOMPLETE_CHARACTERS',
  candTagsListOptions = 'CAND_TAGS_LIST_OPTIONS',
  candSearchAreaDefault = 'CAND_SEARCH_AREA_DEFAULT',
  candCvFileSizeMax = 'CAND_CV_FILE_SIZE_MAX',
  candApplicationsLimitPeriod = 'CAND_APPLICATIONS_LIMIT_PERIOD',
  candFavLimitPeriod = 'CAND_FAV_LIMIT_PERIOD',
  candQualificationsMax = 'CAND_QUALIFICATIONS_MAX',
  candJobQualificationsMax = 'CAND_JOB_QUALIFICATIONS_MAX',
  candThumbnailSizeMax = 'CAND_THUMBNAIL_SIZE_MAX',
  candVideoSizeMax = 'CAND_VIDEO_SIZE_MAX',
  candTagsMaxJobOffer = 'CAND_TAGS_MAX_JOB_OFFER',
  candNameCharsMaxJobOffer = 'CAND_NAME_CHARS_MAX_JOB_OFFER',
  candVideoCvMax = 'CAND_VIDEO_CV_MAX',
  candMobileListEstablishmentElements = 'CAND-MOBILE-LIST-EST-ELEMENTS',
  candMobileListEstablishmentSearchMaxChars = 'CAND-MOBILE_LIST_SEARCH_MAX_CHARS',
  candMobileMaxJobsList = 'CAND-MOBILE-EST-LIST-JOBS-MAX',
}

export default CandidateSettingCodeEnum;
